import { useCallback, useState } from 'react';
import { acknowledgeScreeningEvent } from '../network';

export const useAcknowledgeScreeningEvent = (): [
  boolean,
  boolean,
  Error | null,
  (id: string, verification_request_id: string) => Promise<void>,
  React.Dispatch<React.SetStateAction<Error | null>>
] => {
  const [result, setResult] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async (id: string, verification_request_id: string) => {
    setIsLoading(true);
    setError(null);

    try {
      await acknowledgeScreeningEvent(id, verification_request_id);
      setResult(true);
    } catch (e) {
      const err = e instanceof Error ? e : new Error('Unknown error');
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return [result, isLoading, error, request, setError];
};
